import Image from 'next/image';
import { ProductDescriptionMediaItemProps } from "./constants"
import ReactPlayer from 'react-player/youtube';
import Cookies from 'js-cookie';
import { motion } from 'framer-motion';
import { motionVariants } from '../Common/GlobalVars';
import { useEffect, useRef, useState } from 'react';
import SmartPumping from './CustomDescription/SmartPumping';


interface ProductDescriptionItemProps {
  name: string;
  description_media_list: Array<ProductDescriptionMediaItemProps>;
}

const Description = (props: ProductDescriptionItemProps) => {
  const viewport = Cookies.get('viewport');
  const { name, description_media_list } = props;
  const [videoHeight, setVideoHeight] = useState(0);
  const [fullVideoHeight, setFullVideoHeight] = useState(0);
  const fullVideoRef = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (videoRef.current !== null) {
      setVideoHeight(videoRef.current.offsetWidth * 0.5625);
    }
  }, [])

  useEffect(() => {
    if (fullVideoRef.current !== null) {
      setFullVideoHeight(fullVideoRef.current.offsetWidth * 0.5625);
    }
  }, [])

  const renderCustomDescription = (custom: string | undefined) => {
    switch (custom) {
      case "x1_smart_pumping":
        return (
          <SmartPumping />
        )

      default:
        return (
          <></>
        )
    }
  }

  return (
    <>
      {description_media_list.map((desc, index) => (
        <motion.div
          className={`w-full ${desc.type === "image" ? "" : "my-5"} md:container`}
          key={index}
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true }}
          variants={motionVariants}
        >
          {desc.type === "image" && (
            <>
              {desc.desktop_image.length > 0 && (<Image
                src={desc.desktop_image}
                alt={name + " description image"}
                width={0}
                height={0}
                quality={100}
                sizes="100vw"
                className="hidden w-full h-auto md:block"
              />)}
              {desc.mobile_image.length > 0 && (
                <Image
                  src={desc.mobile_image}
                  alt={name + " description image"}
                  width={0}
                  height={0}
                  quality={100}
                  sizes="100vw"
                  className="w-full h-auto md:hidden"
                />
              )}
            </>
          )}
          {desc.type === "image+text" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 gap-x-10">
              <div className={index % 2 === 0 ? "order-1" : "order-1 md:order-2"}>
                {desc.desktop_image.length > 0 && (<Image
                  src={desc.desktop_image}
                  alt={name + " description image"}
                  width={0}
                  height={0}
                  quality={100}
                  sizes="100vw"
                  className="hidden w-full h-auto md:block"
                />)}
                {desc.mobile_image.length > 0 && (<Image
                  src={desc.mobile_image}
                  alt={name + " description image"}
                  width={0}
                  height={0}
                  quality={100}
                  sizes="100vw"
                  className="w-full h-auto md:hidden"
                />)}
              </div>
              <div className={`${index % 2 === 0 ? "order-2" : "order-1"} ${viewport === "desktop" ? "" : "container"}`}>
                <div className={`text-base font-bold text-black font-poppins ${index % 2 === 0 ? "text-left" : "md:text-right"}`}>{desc.text.title}</div>
                <div className={`mt-2 text-sm font-normal text-black font-poppins ${index % 2 === 0 ? "text-left" : "md:text-right"}`}>{desc.text.content}</div>
              </div>
            </div>
          )}
          {desc.type === "video" && desc.video_link !== undefined && desc.video_link.length > 0 && (
            <div ref={fullVideoRef} className="w-full">
              <ReactPlayer
                url={desc.video_link}
                width="100%"
                height={fullVideoHeight}
                playing={false}
                loop={true}
                controls={true}
                muted={true}
              />
            </div>
          )}
          {desc.type === "video+text" && (
            <div className="grid grid-cols-1 gap-y-5 gap-x-10 md:grid-cols-2">
              <div className={index % 2 === 0 ? "order-2 md:order-1" : "order-2"} ref={videoRef}>
                {desc.video_link !== undefined && desc.video_link.length > 0 && (
                  <ReactPlayer
                    url={desc.video_link}
                    width="100%"
                    height={videoHeight}
                    playing={false}
                    loop={true}
                    controls={true}
                    muted={true}
                  />
                )}
              </div>
              <div className={`${viewport === "desktop" ? "" : "container"} ${index % 2 === 0 ? "order-1 md:order-2" : "order-1 md:text-right"}`}>
                <div className="text-base font-bold text-black font-poppins">{desc.text.title}</div>
                <div className="mt-2 text-sm font-normal text-black font-poppins">{desc.text.content}</div>
              </div>
            </div>
          )}
          {desc.type === "custom" && renderCustomDescription(desc.custom)}
        </motion.div>
      ))}
    </>
  )
}

export default Description
